import { Details } from '../models/details.interfaces';

export const PlatinumMedallionBannerDetailsMocks: Details = {
  title: 'Good Morning, Rocky',
  action: {
    label: 'VIEW YOUR BENEFITS',
    url: '/us/en/skymiles/medallion-program/medallion-benefits'
  },
  milesData: {
    skyMiles: { title: 'SKYMILES #', subtitle: '8006270311' },
    miles: { title: 'MILES AVAILABLE', subtitle: '38,000' }
  },
  tier: {
    title: '2023 CURRENT STATUS: ',
    subtitle: 'PLATINUM MEDALLION®',
    level: '0',
    name: 'platinum'
  }
};

export const PlatinumMillionMilerMedallionBannerDetailsMocks: Details = {
  title: 'Good Morning, Rocky',
  action: {
    label: 'VIEW YOUR BENEFITS',
    url: '/us/en/skymiles/medallion-program/medallion-benefits'
  },
  milesData: {
    skyMiles: { title: 'SKYMILES #', subtitle: '8006270311' },
    miles: { title: 'MILES AVAILABLE', subtitle: '38,000' }
  },
  tier: {
    title: '2023 CURRENT STATUS: ',
    subtitle: 'PLATINUM MEDALLION®',
    level: '1',
    name: 'platinum'
  }
};

export const PlatinumMedallionBannerWithLifetimeDetailsMocks: Details = {
  title: 'Good Morning, Rocky',
  action: {
    label: 'VIEW YOUR BENEFITS',
    url: '/us/en/skymiles/medallion-program/medallion-benefits'
  },
  milesData: {
    skyMiles: { title: 'SKYMILES #', subtitle: '8006270311' },
    miles: { title: 'MILES AVAILABLE', subtitle: '38,000' }
  },
  tier: {
    title: '2023 CURRENT STATUS: ',
    subtitle: 'PLATINUM MEDALLION®',
    level: '0',
    name: 'platinum'
  }
};
